export const PAGES_KEYS = {
    ACTIVITIES: 'ca79a7c5-13bc-4325-b902-68ba3315b58a',
    ACTIVITY: 'a2deb149-8940-4982-9991-53f34643e791',
    ACTIVITYHISTORAL: 'b63da8f7-ad0e-4df7-954a-abe600e44a96',
    BILLS: '3bbb8b1e-6932-40dd-9474-c68062e69a4f',
    HOME: '64d8beb8-abc9-4e2e-9aa1-c96b8f3571ef',
    POSITIONS_RESULTS: 'bce7a4cd-6e28-40a6-880a-5b332ba1a5a5',
    ACTIVITIES_HISTORY_FILTER: 'e3a609d6-8017-4ff7-8d72-f4cd618a4acf'
}